import { Injectable } from "@angular/core";
import { Adapter } from "./adapter";

export class Product {
    public Product_ID: any = null;
    public Product_Code: any = null;
    public Product_Desc: any = null;
    public Category_ID: any = null;
    public SubCategory_ID: any = null;
    public Brand_ID: any = null;
    public Manufacturer_ID: any = null;
    public DosageForm_ID: any = null;
    public RouteAdmin_ID: any = null;
    public Drug_Schedule_ID: any = null;
    public HSN_ID: any = null;
    public Division_ID: any = null;
    public OfferProduct: any = null;
    public UOM_ID: any = null;
    public Packsize: any = null;
    public MRP: any = null;
    public MainImagePath: any = null;
    public Prescription_ID: any = null;
    public NoOfMolecules: any = null;
    public Special_Remark: any = null;
    public SpecialProduct: any = null;
    public SpecialRate: any = null;
    public NewProduct: any = null;
    public Expiry: any = null;
    public Generic: any = null;
    public HalfSchemeAllow: any = null;
    public QuarterSchemeAllow: any = null;
    public LockBilling: any = null;
    public Lock: any = null;
    public BarCode: any = null;
    public DiscountType: any = null;
    public DiscountValue: any = null;
    public PurchaseExpiry: any = null;
    public SalesExpiry: any = null;
    public ReturnExpiry: any = null;
    public StockOutwardMethod_ID: any = null;
    public Active: any = null;
    public Molecule_ID: any = null;
    public CreatedOn: any = null;
    public CreatedBy: any = null;
    public ModifiedBy: any = null;
    public ModifiedOn: any = null;

    constructor(public initVal: Partial<Product>) {
        Object.assign(this, initVal);
    }
}

export class DiscountType {
    public DiscountType_ID: any = null;
    public DiscountType_Code: any = null;
    public DiscountType_Name: any = null;
    public Active: any = null;
    public CreatedBy: any = null;
    public CreatedOn: any = null;
    public ModifiedBy: any = null;
    public ModifiedOn: any = null;

    constructor(public initVal: Partial<DiscountType>) {
        Object.assign(this, initVal);
    }
}

@Injectable()
export class ProductAdapter implements Adapter<Product> {
    adapt(item): Product {
        return new Product(item);
    }
}

@Injectable()
export class DiscountTypeAdapter implements Adapter<DiscountType> {
    adapt(item): DiscountType {
        return new DiscountType(item);
    }
}